module.exports = __webpack_public_path__ + "static/media/my-account-bg.956fb088.jpg";